module.exports = __webpack_public_path__ + "img/highNoon.f32e49e4.png";